import { call, delay, put, select, takeEvery, takeLeading } from 'typed-redux-saga'
import {
	bgLimitRequestApi,
	ClientLimitInfo,
	ClientLimitInfoNS,
	clientLimitInfoSelector,
	clientLimitInfoSLice,
	ClientLimitSupportInfoModel,
} from 'Pages/ibro'
import { Deserialize } from 'cerialize'
import { errorHandler, dadataApi } from 'Modules'

let task
let getDadataTask

function* getClientLimit(action: ClientLimitInfoNS.GetInfo) {
	try {
		const info = yield* call(bgLimitRequestApi.getClientLimitSupportInfo, action.payload)

		yield* put(
			clientLimitInfoSLice.actions.setSupportInfo(Deserialize(info, ClientLimitSupportInfoModel))
		)
		if (!info?.permitted) return

		yield* put(clientLimitInfoSLice.actions.setLoading(true))
		yield* call(bgLimitRequestApi.getClientLimit, action.payload)
		yield* put(clientLimitInfoSLice.actions.setDisableNext(true))

		yield* delay(3000)

		yield* put(clientLimitInfoSLice.actions.setDisableNext(false))
		// eslint-disable-next-line no-empty
	} catch (error) {}
}

function* handleClientLimitMessage(action: ClientLimitInfoNS.HandleClientLimitMessage) {
	try {
		const loading = yield* select(clientLimitInfoSelector.selectLoading)
		if (!loading) return

		yield* put(clientLimitInfoSLice.actions.setOne(action.payload as ClientLimitInfo))
		yield* put(clientLimitInfoSLice.actions.setLoading(false))
		yield* put(clientLimitInfoSLice.actions.setDisableNext(false))
		// eslint-disable-next-line no-empty
	} catch (error) {}
}

function* getDadataInfo(action: ClientLimitInfoNS.GetDadataInfo) {
	try {
		const res = yield* call(dadataApi.getShortName, action.payload.inn)
		yield* put(clientLimitInfoSLice.actions.setDadataInfo(res[0]))
	} catch (e) {
		yield* call(errorHandler, e)
	}
}

function* cancelGetOne() {
	task.cancel()
	task = yield* takeLeading(clientLimitInfoSLice.actions.getOne.type, getClientLimit)
}

function* cancelGetDadataInfo() {
	getDadataTask.cancel()
	getDadataTask = yield* takeLeading(clientLimitInfoSLice.actions.getDadataInfo.type, getDadataInfo)
}

export function* clientLimitInfoSaga() {
	task = yield* takeLeading(clientLimitInfoSLice.actions.getOne.type, getClientLimit)
	getDadataTask = yield* takeLeading(clientLimitInfoSLice.actions.getDadataInfo.type, getDadataInfo)

	yield* takeLeading(
		clientLimitInfoSLice.actions.handleClientLimitMessage.type,
		handleClientLimitMessage
	)
	yield* takeEvery(clientLimitInfoSLice.actions.cancelGetOne.type, cancelGetOne)
	yield* takeEvery(clientLimitInfoSLice.actions.cancelGetDadataInfo.type, cancelGetDadataInfo)
}
